export const getLogoSuccess = (state) => state.logo.saveLogoSuccess;
export const getpreviewLogo = (state) => state.logo.previewLogo;
export const getpreviewLogoUrl = (state) => state.logo.url;
export const getpreviewBiggerFooter = (state) => state.logo.biggerFooter;
